/** Alerts page display helpers and test ids (user alert management, /alerts). */

export const ALERTS_PAGE_TEST_ID = 'alerts-page';
export const ALERTS_EMPTY_STATE_TEST_ID = 'alerts-empty-state';
export const ALERTS_ERROR_STATE_TEST_ID = 'alerts-error-state';
export const ALERT_ROW_TEST_ID_PREFIX = 'alert-row-';

/** Known alert types → i18n label descriptors. Unknown types fall back to a generic label. */
export const ALERT_TYPE_LABELS = {
  listing_reminder: { labelKey: 'alerts.type_listing_reminder', defaultLabel: 'Property reminder' },
};

const GENERIC_TYPE_LABEL = { labelKey: 'alerts.type_generic', defaultLabel: 'Alert' };

export function alertTypeLabel(alert) {
  return ALERT_TYPE_LABELS[alert?.type] || GENERIC_TYPE_LABEL;
}

/** Human title for an alert row: the listing title captured at creation, if any. */
export function alertTitle(alert) {
  const title = alert?.criteria?.listing_title;
  if (typeof title === 'string' && title.trim()) return title.trim();
  return null;
}

/** Link to the related listing detail page, when the alert targets a listing. */
export function alertListingHref(alert) {
  return alert?.listing_id ? `/listings/${alert.listing_id}` : null;
}

/** PATCH query params to flip an alert's active state (backend expects query param). */
export function alertToggleParams(alert) {
  return { is_active: !(alert?.is_active ?? true) };
}

/** Pure state update: flip is_active for one alert id. */
export function applyAlertToggle(alerts, alertId) {
  return (alerts || []).map((item) =>
    item.id === alertId ? { ...item, is_active: !(item.is_active ?? true) } : item,
  );
}

/** Pure state update: remove one alert id. */
export function removeAlertById(alerts, alertId) {
  return (alerts || []).filter((item) => item.id !== alertId);
}

/** Newest alerts first; invalid dates sink to the end. Does not mutate input. */
export function sortAlertsNewestFirst(alerts) {
  const time = (value) => {
    const parsed = new Date(value).getTime();
    return Number.isNaN(parsed) ? -Infinity : parsed;
  };
  return [...(alerts || [])].sort((a, b) => time(b?.created_at) - time(a?.created_at));
}
